import { formatLargeNumber } from 'lib/helpers/utility';

export const PAGE_SIZE_OPTIONS = [15, 25, 50, 100, 250, 500].map((value) => ({
  label: formatLargeNumber(value),
  value
}));
